// Environment-based API URLs
//const DEV_API_URL = "http://192.168.101.202:8001"; // Local/Development
const DEV_API_URL = ""; // Local/Development
const PROD_API_URL = "https://administrator.lokadhikar.in"; // Production
//const PROD_API_URL = ""; // Production

// Choose API URL based on environment
const CONFIG = {
  API_BASE_URL:
    process.env.NODE_ENV === "production" ? PROD_API_URL : DEV_API_URL,

  PROJECT_NAME: "महाराष्ट्र लोकाधिकार समिती",
  VERSION: "1.0.0",
};

export default CONFIG;